import history from 'app/history';
import Routes from 'app/routes';
import { useSoundAction } from 'hooks';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { doLogout } from 'slices';

export function useLogout() {
    const [visible, setVisible] = useState(false);
    const dispatch = useDispatch();

    const callbacks = {
        doLogout: (callback) => {
            dispatch(doLogout()).then(() => {
                setVisible(false);
                history.push(Routes.LOGIN);
                if (typeof callback === 'function') callback();
            });
        },

        declineLogout: useCallback(() => {
            setVisible(false);
        }, []),

        showLogoutBox: useCallback(() => {
            setVisible(true);
        }, []),
    };

    const handleLogout = useSoundAction('logout', callbacks.doLogout);

    return { visible, callbacks, handleLogout };
}
